import "./ShipmentGroupCreateView.scss";
import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import IVendorModel from "../../../../models/IVendorModel";
import IClient from "../../../../models/IClient";
import OrderSourceEnum from "../../../../models/OrderSourceEnum";
import OwButton from "../../../shared/OwButton/OwButton";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import Typeahead from "../../../shared/Typeahead/Typeahead";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import AddressDisplay from "../../../shared/AddressDisplay/AddressDisplay";
import * as _ from "lodash-es";
import AddressBlock from "../../../shared/AddressBlock/AddressBlock";
import OwCheckbox from "../../../shared/OwCheckbox/OwCheckbox";
import IOrder from "../../../../models/IOrder";
import SupplierContext from "../../../../contexts/SupplierContext";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import { Socket } from "socket.io-client";
import IUiSocketSetup from "../../../../models/IUiSocketSetup";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import IGetVendorsDTO from "../../../../models/DTO/IGetVendorsDTO";
import UserContext from "../../../../contexts/UserContext";
import IOnGetVendorsDTO from "../../../../models/DTO/IOnGetVendorsDTO";
import IShipment_GroupUI from "../../../../models/IShipment_GroupUI";
import IOnGetOrdersDTO from "../../../../models/DTO/IOnGetOrdersDTO";
import IGetOrdersDTO from "../../../../models/DTO/IGetOrdersDTO";
import IGetOrdersTypeaheadDTO from "../../../../models/DTO/IGetOrdersTypeaheadDTO";
import IOnGetOrdersTypeaheadDTO from "../../../../models/DTO/IOnGetOrdersTypeaheadDTO";
import INewAddress from "../../../../models/INewAddress";
import IShipment_Group from "../../../../models/IShipment_Group";
import IGetOrderDTO from "../../../../models/DTO/IGetOrderDTO";
import IOnGetOrderDTO from "../../../../models/DTO/IOnGetOrderDTO";
import { SocketContext } from "../../../../contexts/SocketContext";
import UiContext from "../../../../contexts/UiContext";
import IAddress from "../../../../models/IAddress";

type Props = {
    cancel: () => void;
    headerTitle: string;
    isFormValid: () => boolean;
    shipTo?: INewAddress;
    billTo?: INewAddress;
    shipmentGroup?: IShipment_GroupUI;
    selectedVendor?: IVendorModel | IClient;
    selectedOrders: IOrder[];
    restrictedView: boolean;
    removeOrderFromShipment: (order: IOrder, index: number) => void;
    setSelectedOrdersFn: (orders: IOrder[]) => void;
    setSelectedVendorFn: (vendor: IVendorModel | undefined) => void;
    isLocalPickup: boolean;
    isLocalDelivery: boolean;
    isDropshipment: boolean;
    setShipToFn: (shipTo: INewAddress) => void;
    setBillToFn: (billTo: INewAddress) => void;
    setIsLocalPickup: (isLocalPickup: boolean) => void;
    setIsLocalDelivery: (isLocalDelivery: boolean) => void;
    setIsDropshipment: (isDropshipment: boolean) => void;
    setCreateInShipstation: (isDropshipment: boolean) => void;
    setBillToSameAsShipTo: (billToSameAsShipTo: boolean) => void;
    changeView: (view: "create" | "review") => void;
    createInShipstation: boolean;
    billToSameAsShipTo: boolean;
    getDefaultCountry: (country: string) => string;
};

export const ShipmentGroupCreateView = (props: Props) => {
    const supplierModel = useContext(SupplierContext);
    const userModel = useContext(UserContext);
    const socket = useContext(SocketContext)!;
    const uiContext = useContext(UiContext);

    const getShipmentObject = (type: "Ship_To" | "Bill_To", data?: IShipment_Group) => {
        return {
            name: _.get(data, `${type}.name`, ""),
            company_name: _.get(data, `${type}.company_name`, ""),
            address_line_one: _.get(data, `${type}.address_line_one`, ""),
            address_line_two: _.get(data, `${type}.address_line_two`, ""),
            city: _.get(data, `${type}.city`, ""),
            state: _.get(data, `${type}.state`, ""),
            postal_code: _.get(data, `${type}.postal_code`, ""),
            country: props.getDefaultCountry(_.get(data, `${type}.country`, "")),
        };
    };

    const [autoSelectVendor, setAutoSelectVendor] = useState(!!props.shipmentGroup?.action || false);
    const [foundVendors, setFoundVendors] = useState<IVendorModel[]>([]);
    const [vendorOrders, setVendorOrders] = useState<IOrder[]>([]);
    const [isOrderSearchDisabled, setIsOrderSearchDisabled] = useState(false);
    const [isCarrierDisabled, setIsCarrierDisabled] = useState(false);
    const [availableOrders, setAvailableOrders] = useState<IOrder[]>([]);
    const [hasOrderShipTo, setHasOrderShipTo] = useState(false);
    const [clearVendorTypeahead, setClearVendorTypeahead] = useState<boolean>(false);
    const [clearOrdersTypeahead, setClearOrdersTypeahead] = useState<boolean>(false);
    const [shipTo, setShipTo] = useState<INewAddress | undefined>(props.shipTo || getShipmentObject("Ship_To", props.shipmentGroup));
    const [billTo, setBillTo] = useState<INewAddress | undefined>(props.shipTo || getShipmentObject("Ship_To", props.shipmentGroup));
    // const [billToSameAsShipTo, setBillToSameAsShipTo] = useState<boolean>(_.get(props.shipmentGroup, "bill_to_same_as_ship_to", true));
    const [countries, setCountries] = useState<any[]>([]);

    const getOrdersTypeahead = (name: string) => {
        if (props.selectedVendor) {
            const payload: IGetOrdersTypeaheadDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                vendorGuid: props.selectedVendor.guid,
                queryString: `order=${name}`,
            };

            socket.emit(EndpointsEnum.OrderGetOrdersTypeahead, payload);
        }
    };

    const onGetOrdersTypeahead = (data: IOnGetOrdersTypeaheadDTO) => {
        setAvailableOrders(data.orders);
    };

    /**
     * Get the orders for the selected vendor
     */
    const getOrders = () => {
        if (_.isNil(props.selectedVendor)) {
            return;
        }

        const data: IGetOrdersDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            vendorGuid: props.selectedVendor.guid,
            supplierGuid: supplierModel.guid,
            callMeta: {
                view: "CreateShipmentGroupSidebar",
                fn: "getOrders",
            },
        };

        socket.emit(EndpointsEnum.OrderGetOrders, data);
    };

    const onGetOrders = (data: IOnGetOrdersDTO) => {
        setVendorOrders(data.orders);
    };

    const getNewGroupVendorFromParams = () => {
        if (userModel.isSupplierUser) {
            const data: IGetVendorsDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                offset: 0,
                limit: 1000,
            };

            if (!_.isNil(props.shipmentGroup) && props.shipmentGroup.action?.vendor_name) {
                data.limit = 10;
                const urlEncodedName = encodeURIComponent(props.shipmentGroup.action.vendor_name);
                data.queryString = `name=${urlEncodedName}`;
            }

            // this.socket.emit('getAllSupplierTokens', data);
            socket.emit(EndpointsEnum.VendorsGetVendors, data);
        }
    };

    const findVendorsByName = (typeahead: string) => {
        setAutoSelectVendor(false);

        console.log("findVendorsByName: ", typeahead, autoSelectVendor);

        socket.removeListener(EndpointsEnum.VendorsOnGetVendors, onGetVendors);
        socket.on(EndpointsEnum.VendorsOnGetVendors, onGetVendors);

        const encodedTypeahead = encodeURIComponent(typeahead);

        const payload: IGetVendorsDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            queryString: `name=${encodedTypeahead}`,
        };

        socket.emit(EndpointsEnum.VendorsGetVendors, payload);
    };

    const onGetVendors = (data: IOnGetVendorsDTO) => {
        let autoSelectedVendor;

        const _foundVendors = data.supplierVendorTokens
            .filter((tokenData) => !!tokenData.Vendor)
            .map((tokenData) => {
                if (!_.isNil(props.shipmentGroup) && autoSelectVendor && props.shipmentGroup.action && tokenData.Vendor) {
                    if (tokenData.Vendor.guid === props.shipmentGroup.action.vendor_guid) {
                        autoSelectedVendor = tokenData.Vendor;
                    }
                }

                return tokenData.Vendor!;
            });

        if (!_.isNil(props.shipmentGroup) && autoSelectVendor && !_.isNil(autoSelectedVendor)) {
            props.setSelectedVendorFn(autoSelectedVendor);
            setIsOrderSearchDisabled(false);
            setFoundVendors([]); // null?
            setIsCarrierDisabled(false);
        } else {
            setFoundVendors(_foundVendors);
        }
    };

    const sockets: IUiSocketSetup[] = [
        // {endpoint: EndpointsEnum.TokenOnGetAllSupplierTokens, fn: onGetAllSupplierTokens},
        { endpoint: EndpointsEnum.OrderOnGetOrdersTypeahead, fn: onGetOrdersTypeahead },
        { endpoint: EndpointsEnum.OrderOnGetOrders, fn: onGetOrders },
        { endpoint: EndpointsEnum.VendorsOnGetVendors, fn: onGetVendors },
    ];

    useEffect(() => {
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        getNewGroupVendorFromParams();
        getOrders();

        return () => {
            for (const _socket of sockets) {
                socket.removeListener(_socket.endpoint, _socket.fn);
            }
        };
    }, []);

    useEffect(() => {
        setShipTo(props.shipTo);
    }, [props.shipTo]);

    useEffect(() => {
        setShipTo(props.billTo);
    }, [props.billTo]);

    useEffect(() => {
        if (!_.isNil(props.shipmentGroup) && props.shipmentGroup.action && !_.isNil(props.selectedVendor)) {
            getOrders();
        }
    }, [props.selectedVendor]);

    useEffect(() => {
        if (props.selectedOrders && props.selectedOrders.length === 1) {
            if (!_.isNil(props.selectedOrders[0]?.ship_to_id)) {
                setHasOrderShipTo(true);
            }
        }
    }, [props.selectedOrders]);

    const formatSelectedOrders = () => {
        const orders = props.selectedOrders;

        if (_.isNil(orders) || !orders.length) {
            return;
        }

        return orders.map((order, index) => {
            return (
                <div className="col-6" key={index}>
                    <span
                        className="pointer"
                        onClick={(e) => {
                            props.removeOrderFromShipment(order, index);
                        }}>
                        <i className="fas fa-times text-danger" />
                    </span>{" "}
                    {order?.name}
                </div>
            );
        });
    };

    const updateSelectedOrders = (order: IOrder) => {
        const selectedOrders = [order, ...props.selectedOrders];

        setAvailableOrders([]);
        props.setSelectedOrdersFn(selectedOrders);
    };

    // return <div className={"ShipmentGroupCreateView"}>
    //
    // </div>;
    const selectedOrderIds = formatSelectedOrders();

    let vendorShipTo: IVendorModel | IClient = props.selectedVendor!;

    let disableAdditionalOrders = false;

    if (props.selectedOrders && props.selectedOrders.length) {
        const selectedOrder = props.selectedOrders[0];

        if (selectedOrder?.order_source_id !== OrderSourceEnum.ORDERWERKS) {
            if (selectedOrder?.Client) {
                vendorShipTo = selectedOrder.Client;
            }

            if (props.selectedOrders.length === 1) {
                disableAdditionalOrders = true;
            }
        }

        if (selectedOrder?.qbo_EntityId) {
            disableAdditionalOrders = true;
        }
    }

    const populateShipToWithVendorAddress = () => {
        let usingShipToCompanyName = false;

        let name: string | undefined = _.get(props.selectedVendor, "Ship_To.name", "");

        if (_.isNil(name) || !name.length) {
            name = _.get(props.selectedVendor, "Ship_To.company_name", "");
            usingShipToCompanyName = true;

            if (_.isNil(name) || !name.length) {
                name = _.get(props.selectedVendor, "name", "");
            }
        }

        let country: string | undefined = props.getDefaultCountry(_.get(props.selectedVendor, "Ship_To.country", "USA"));

        if (_.isNil(country)) {
            country = "USA";
        }

        let addressObj = props.selectedVendor?.Ship_To || ({} as IAddress);

        if (props.selectedOrders && props.selectedOrders.length) {
            const selectedOrder = props.selectedOrders[0];

            if (selectedOrder.order_source_id !== OrderSourceEnum.ORDERWERKS) {
                addressObj = selectedOrder.Client?.Ship_To || ({} as IAddress);
                name = selectedOrder.Client?.Ship_To?.name;
                country = selectedOrder.Client?.Ship_To?.country;
            }
        }

        const _shipTo = {
            name,
            company_name: !usingShipToCompanyName ? _.get(props.selectedVendor, "Ship_To.company_name", "") : "",
            address_line_one: addressObj.address_line_one,
            address_line_two: addressObj.address_line_two,
            city: addressObj.city,
            state: addressObj.state,
            postal_code: addressObj.postal_code,
            country,
        };

        props.setShipToFn(_shipTo);
    };

    const populateShipToWithOrderShipTo = () => {
        let order;

        let name;

        let addressObj = {} as INewAddress;

        let usingShipToCompanyName = false;

        // existing shipment group...
        if (!_.isNil(props.shipmentGroup) && !_.isNil(props.shipmentGroup.Orders)) {
            order = props.shipmentGroup.Orders[0];
            name = _.get(order, "Ship_To.name", "");

            if (_.isNil(name) || !name.length) {
                name = _.get(order, "Ship_To.company_name", "");
                usingShipToCompanyName = true;

                if (_.isNil(name) || !name.length) {
                    name = _.get(order, "name", "");
                }
            }
        } else {
            // new shipment group...
            order = props.selectedOrders[0];

            name = _.get(order, "Ship_To.name", "");
        }

        if (!_.isNil(order.Ship_To)) {
            addressObj = {
                address_line_one: _.get(order, "Ship_To.address_line_one", ""),
                address_line_two: _.get(order, "Ship_To.address_line_two", ""),
                city: _.get(order, "Ship_To.city", ""),
                state: _.get(order, "Ship_To.state", ""),
                postal_code: _.get(order, "Ship_To.postal_code", ""),
            };
        } else {
            if (props.selectedVendor?.Ship_To) {
                addressObj = props.selectedVendor!.Ship_To;
            }
        }

        let country = props.getDefaultCountry(_.get(order, "Ship_To.country", "USA"));

        if (_.isNil(country)) {
            country = "USA";
        }

        const _shipTo = {
            name,
            company_name: !usingShipToCompanyName ? order?.Ship_To?.company_name : "",
            address_line_one: addressObj.address_line_one,
            address_line_two: addressObj.address_line_two,
            city: addressObj.city,
            state: addressObj.state,
            postal_code: addressObj.postal_code,
            country,
        };

        props.setShipToFn(_shipTo);
    };

    const updateSelectedVendor = (vendor: IVendorModel) => {
        props.setSelectedVendorFn(vendor);
    };

    const resetShipment = () => {};

    const handleChange = (e: ChangeEvent<any>) => {
        // this data will update this components state, as well as the parent component's state
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        switch (name) {
            case "bill_to_same_as_ship_to":
                props.setBillToSameAsShipTo(value);
                break;

            case "is_dropshipment":
                props.setIsDropshipment(value);
                props.setIsLocalPickup(false);
                props.setIsLocalDelivery(false);
                break;

            case "is_local_delivery":
                props.setIsLocalDelivery(value);
                props.setIsLocalPickup(false);
                props.setIsDropshipment(false);
                props.setCreateInShipstation(false);
                break;

            case "is_local_pickup":
                props.setIsLocalPickup(value);
                props.setIsDropshipment(false);
                props.setIsLocalDelivery(false);
                props.setCreateInShipstation(false);
                break;

            case "create_in_shipstation":
                props.setCreateInShipstation(value);
                break;
        }
    };

    const handleAddressChange = (e: ChangeEvent<any>, type: "shipTo" | "billTo") => {
        // this data will update this components state, as well as the parent component's state
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const address = {
            ...props[type],
            [name]: value,
        };

        if (type === "shipTo") {
            props.setShipToFn(address);
        } else {
            props.setBillToFn(address);
        }
    };

    const clearTypeaheadCallback = (callback: "clearVendorTypeahead" | "clearOrdersTypeahead") => {
        if (callback === "clearVendorTypeahead") {
            props.setSelectedVendorFn(undefined);
        }
    };

    return (
        <div className="ShipmentGroupCreateView p-3">
            <div style={{ height: "h-5r" }}>
                <div className="text-end">
                    <OwButton
                        fn={() => {
                            props.cancel();
                        }}
                        title={""}
                        centerIconClass={"far fa-times"}
                        className={"btn-danger"}
                    />
                </div>
                <OwTitle className={"mb-2"} leftIconName={"fas fa-truck"} title={props.headerTitle} />
                <hr />
            </div>

            <div>
                <form name={"shipmentGroupForm"}>
                    <div className="mb-4">
                        <OwTitle tag={"h5"} title={"vendor"} isSupplierVendorOverride={true} supplierModel={supplierModel} />

                        <div className="position-relative">
                            <Typeahead
                                clearTypeahead={clearVendorTypeahead}
                                clearTypeaheadCallback={() => {
                                    clearTypeaheadCallback("clearVendorTypeahead");
                                }}
                                typeaheadItems={foundVendors}
                                titleProp="name"
                                subTitleProp=""
                                maxResults={5}
                                placeholder="Search"
                                selectedItem={props.selectedVendor}
                                isSelectableFn={() => {
                                    return true;
                                }}
                                selectedItemFn={updateSelectedVendor}
                                typeaheadApiFn={findVendorsByName}
                                disabled={props.restrictedView}
                            />
                        </div>
                    </div>

                    <div className="mb-4">
                        <div className={"d-flex align-items-center v-align-center"}>
                            <OwTitle title={"order_ids"} tag={"h5"} className={"d-inline-flex"} />
                            <OwLabel
                                title={"add_one_order_req"}
                                className={"ms-2 mb-0 text-small text-danger " + (props.selectedOrders.length ? "d-none" : "d-inline-flex")}
                            />
                        </div>

                        {/* Debugging */}
                        {/*<div>{isOrderSearchDisabled ? "Disabled Order Search" : "Order Search Allowed"}</div>*/}
                        {/*<div>{props.restrictedView ? "Restricted View" : "Not Restricted View"}</div>*/}
                        {/*<div>{disableAdditionalOrders ? "Disable Additional Orders" : "Allow Additional Orders"}</div>*/}

                        {props.selectedVendor ? (
                            <Typeahead
                                wrapperClassName="mb-2 me-sm-2"
                                className=""
                                typeaheadItems={availableOrders}
                                clearTypeahead={clearOrdersTypeahead}
                                clearTypeaheadCallback={() => {
                                    clearTypeaheadCallback("clearOrdersTypeahead");
                                }}
                                titleProp="name"
                                subTitleProp=""
                                maxResults={5}
                                confirmAdd={true}
                                placeholder="Search Order No"
                                isSelectableFn={() => {
                                    return true;
                                }}
                                selectedItemFn={updateSelectedOrders}
                                typeaheadApiFn={getOrdersTypeahead}
                                disabled={isOrderSearchDisabled || props.restrictedView || disableAdditionalOrders}
                            />
                        ) : null}

                        <div>{selectedOrderIds}</div>
                    </div>

                    {props.isLocalPickup ? null : (
                        <div className={"row mb-4"}>
                            <div className={"col " + (props.selectedVendor ? "" : "d-none")}>
                                <OwLabel
                                    isBold={true}
                                    title={"vendor_ship_to"}
                                    supplierModel={supplierModel}
                                    isSupplierVendorOverride={true}
                                />
                                <AddressDisplay
                                    showName={true}
                                    showCompanyName={true}
                                    prefix={"Ship_To."}
                                    address={vendorShipTo}
                                    className={"col-auto"}
                                />
                            </div>

                            <div className={"col " + (props.selectedOrders.length && props.selectedOrders[0]?.Ship_To ? "" : "d-none")}>
                                <OwLabel title={"order_ship_to"} isBold={true} />
                                <AddressDisplay
                                    showName={true}
                                    showCompanyName={true}
                                    prefix={"Ship_To."}
                                    address={props.selectedOrders[0]}
                                    className={"col-auto"}
                                />
                            </div>
                        </div>
                    )}

                    {props.isLocalPickup ? null : (
                        <div className="mb-4">
                            <div>
                                <OwTitle tag={"h5"} title={"ship_to"} className={"d-inline-flex"} />

                                <OwButton
                                    className={"btn-primary ms-5 btn-sm"}
                                    title={"use_vendor_address"}
                                    disabled={_.isNil(props.selectedVendor) || props.restrictedView}
                                    fn={populateShipToWithVendorAddress}
                                    isSupplierVendorOverride={true}
                                    supplierModel={supplierModel}
                                />

                                <OwButton
                                    className={
                                        "btn-primary ms-2 btn-sm " +
                                        (props.selectedOrders.length && props.selectedOrders[0]?.Ship_To ? "" : "d-none")
                                    }
                                    title={"use_order_ship_to_address"}
                                    disabled={_.isNil(props.selectedVendor) || props.restrictedView}
                                    fn={populateShipToWithOrderShipTo}
                                />
                            </div>
                            <div>
                                <AddressBlock
                                    address={props.shipTo}
                                    showName={true}
                                    showCompanyName={true}
                                    companyNameRequired={false}
                                    countries={countries}
                                    prefix={""}
                                    fn={(e: any) => {
                                        handleAddressChange(e, "shipTo");
                                    }}
                                    isDisabled={props.restrictedView}
                                    requiredFields={true}
                                />

                                <div>
                                    <label className="pointer">
                                        <OwCheckbox
                                            name={"bill_to_same_as_ship_to"}
                                            checked={props.billToSameAsShipTo}
                                            fn={handleChange}
                                            disabled={props.restrictedView}
                                            label={"bill_to_same_as_ship_to"}
                                            truthyVal={true}
                                            falsyVal={false}
                                        />{" "}
                                        ?
                                    </label>
                                </div>
                            </div>
                        </div>
                    )}

                    {props.isLocalPickup ? null : (
                        <div className={"mb-4 " + (props.billToSameAsShipTo ? "d-none" : "")}>
                            <OwTitle title={"bill_to"} tag={"h5"} />
                            <div>
                                <AddressBlock
                                    address={props.billTo}
                                    showName={true}
                                    showCompanyName={true}
                                    countries={countries}
                                    prefix={""}
                                    fn={(e: any) => {
                                        handleAddressChange(e, "billTo");
                                    }}
                                    isDisabled={props.restrictedView}
                                    requiredFields={true}
                                    companyNameRequired={false}
                                />
                            </div>
                        </div>
                    )}

                    <div className={"mb-3"}>
                        <OwCheckbox
                            checked={props.isDropshipment}
                            label={"is_dropshipment"}
                            name={"is_dropshipment"}
                            fn={handleChange}
                            truthyVal={true}
                            falsyVal={false}
                        />
                    </div>

                    {supplierModel.has_local_pickup ? (
                        <div className={"mb-3"}>
                            <OwCheckbox
                                checked={props.isLocalPickup}
                                label={"is_local_pickup"}
                                name={"is_local_pickup"}
                                fn={handleChange}
                                truthyVal={true}
                                falsyVal={false}
                            />
                        </div>
                    ) : null}

                    {supplierModel.has_local_delivery ? (
                        <div className={"mb-3"}>
                            <OwCheckbox
                                checked={props.isLocalDelivery}
                                label={"is_local_delivery"}
                                name={"is_local_delivery"}
                                fn={handleChange}
                                truthyVal={true}
                                falsyVal={false}
                            />
                        </div>
                    ) : null}

                    {supplierModel.Supplier_Integration.has_shipstation &&
                    !props.shipmentGroup?.shipstation_order_key &&
                    !props.shipmentGroup?.guid ? (
                        <div className={"mb-2"}>
                            <OwCheckbox
                                checked={props.createInShipstation}
                                label={"create_in_shipstation"}
                                name={"create_in_shipstation"}
                                fn={handleChange}
                                truthyVal={true}
                                falsyVal={false}
                            />
                        </div>
                    ) : null}

                    <div className="mb-4">
                        <OwButton
                            className={"btn-primary me-3"}
                            leftIconClass={"fas fa-list"}
                            title={"review"}
                            disabled={!props.isFormValid}
                            fn={() => {
                                props.changeView("review");
                            }}
                        />

                        {props.shipmentGroup && props.shipmentGroup.guid ? null : (
                            <OwButton className={"btn-danger"} leftIconClass={"fas fa-eraser"} title={"clear"} fn={resetShipment} />
                        )}
                    </div>
                </form>
            </div>
        </div>
    );
};
